<template>
    <v-container>
        <base-hero-simple class="mb-2">
            <base-router-links :items="links" />
        </base-hero-simple>
        <v-overlay :absolute="true" :value="loading || $apollo.loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
        <v-overlay :absolute="true" opacity="1" :value="noBranches">
            <div style="display: flex; flex-direction: column; text-align: center">
                <h2
                    >It looks like you've reached this page by accident. Please click
                    <a @click="$router.push({ name: 'home' })">here</a> to go back to the homepage.</h2
                >
            </div>
        </v-overlay>
        <div class="container-bg" style="margin: auto">
            <div class="container-fg">
                <div style="display: flex; flex-direction: row">
                    <v-row>
                        <v-col cols="10">
                            <div style="display: flex; flex-direction: row">
                                <img
                                    style="width: 130px; margin-top: 10px"
                                    src="../../../assets/logos/getac-logo.svg"
                                />
                                <div class="text-h7 nav-font pl-3" style="margin-top: 22px">ACCOUNT ORGANIZATIONS</div>
                            </div>
                        </v-col>
                        <v-col cols="2">
                            <!-- <v-select
                                v-if="checkAdmin(currentLevel)"
                                v-model="currentView"
                                :items="viewOptions"
                                dark
                                outlined
                            ></v-select> -->
                        </v-col>
                    </v-row>
                </div>
                <v-divider style="margin-bottom: 1%; border-color: gray" />
                <div v-if="currentView === 'Table View'" class="org-container">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel" class="expanded-panels" dark accordion mandatory>
                                <v-expansion-panel>
                                    <v-expansion-panel-header class="expansion-header-first" expand-icon="">
                                        <v-col cols="4" style="text-align: center">
                                            <v-tooltip
                                                v-if="
                                                    currentLevel.parentOrgId &&
                                                    baseLevelId !== currentLevel.baseAccountId
                                                "
                                                bottom
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="currentLevel.baseAccountId = currentLevel.parentOrgId"
                                                    >
                                                        <v-list-item-subtitle style="color: gray; margin-bottom: 10px">
                                                            Previous Branch
                                                        </v-list-item-subtitle>
                                                        <v-icon color="#db5120">{{ mdiArrowLeft }}</v-icon>
                                                    </div>
                                                </template>
                                                <span>{{ currentLevel.parentOrgName }} </span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="4" style="text-align: center"
                                            ><v-list-item-subtitle style="color: gray; margin-bottom: 5px">
                                                Organization
                                            </v-list-item-subtitle>
                                            <h1 style="font-size: 36px; letter-spacing: -0.01rem">
                                                {{ currentLevel.baseAccountName }}
                                            </h1>
                                            <v-list-item-subtitle
                                                v-if="currentLevel.address"
                                                class="mt-2"
                                                style="color: gray; margin-bottom: 5px"
                                            >
                                                <print-org-address :address="currentLevel.address" />
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="4" style="text-align: right">
                                            <update-org
                                                v-if="checkAdmin(currentLevel)"
                                                :current-level="currentLevel"
                                                :table-view="tableView"
                                                :delete-only="false"
                                                @updated="updateData"
                                                @deleted="deletedOrg($event)"
                                            ></update-org>
                                        </v-col>
                                    </v-expansion-panel-header>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="checkAdmin(currentLevel) && currentLevel.enterprise" cols="12">
                            <div class="org-users-section">
                                <v-navigation-drawer width="100%" dark permanent floating>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-list-item-subtitle style="margin-top: 7px">
                                                        Organizations Under
                                                        {{ currentLevel.baseAccountName }}
                                                    </v-list-item-subtitle>
                                                </v-col>
                                                <v-col cols="4"> </v-col>
                                                <v-col cols="4" style="text-align: right">
                                                    <create-sub-org
                                                        :no-parent-org="false"
                                                        :current-level="currentLevel"
                                                        :table-view="tableView"
                                                        @created="updateData"
                                                    ></create-sub-org>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-navigation-drawer>
                                <v-data-table
                                    style="background-color: transparent"
                                    dark
                                    class="org-data-table"
                                    :items="currentLevel.childrenOrg"
                                    hide-default-footer
                                    :no-data-text="`No sub-organizations exist under ${currentLevel.baseAccountName}`"
                                    :headers="subOrgHeaders"
                                    disable-sort
                                >
                                    <template v-slot:item.address="{ item }">
                                        <div v-if="item.address">
                                            <print-org-address :address="item.address" />
                                        </div>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-btn
                                            color="primary"
                                            elevation="0"
                                            outlined
                                            small
                                            @click="currentLevel.baseAccountId = item.orgId"
                                            >View</v-btn
                                        >
                                    </template>
                                </v-data-table>
                            </div>
                        </v-col>

                        <v-row class="pr-3 pl-3">
                            <v-col :cols="addPossibleUsersAccess ? '7' : '12'">
                                <div class="org-users-section">
                                    <v-navigation-drawer width="100%" dark permanent floating>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="4">
                                                        <v-list-item-subtitle style="margin-top: 7px">
                                                            User Accounts
                                                        </v-list-item-subtitle>
                                                    </v-col>
                                                    <v-col cols="4"> </v-col>
                                                    <v-col cols="4" style="text-align: right">
                                                        <add-user
                                                            v-if="checkAdmin(currentLevel)"
                                                            :current-level="currentLevel"
                                                            :table-view="tableView"
                                                            @added="updateData"
                                                        ></add-user>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-navigation-drawer>

                                    <v-data-table
                                        style="background-color: transparent"
                                        dark
                                        class="org-data-table"
                                        no-data-text="No accounts have been added under this organization"
                                        :items="currentLevel.accounts"
                                        :headers="userHeaders"
                                        :search="searchUserAccounts"
                                        disable-sort
                                    >
                                        <template v-slot:top>
                                            <v-text-field
                                                v-model="searchUserAccounts"
                                                label="Search Current User Accounts"
                                                outlined
                                                dense
                                                class="mx-4 mt-10"
                                            ></v-text-field>
                                        </template>
                                        <template v-slot:item.email="{ item }">
                                            <span v-if="item.account">{{ item.account.email }}</span>
                                            <span v-if="!item.account"> {{ item.requestedEmail }}</span>
                                            <v-chip v-if="item.admin" class="ma-2" color="orange" label small>
                                                Admin
                                                <v-icon>{{ mdiAccountSupervisor }}</v-icon>
                                            </v-chip>
                                            <v-chip v-if="!item.account" class="ma-2" color="gray" label small>
                                                Pending
                                            </v-chip>
                                            <v-chip v-if="item.isAccountLocked" color="red" class="ma-2" label small>
                                                Disabled</v-chip
                                            >
                                        </template>
                                        <template v-if="checkTopOrg()" v-slot:item.access="{ item }">
                                            <v-btn>
                                                <span class="pa-0" small @click="userAccountAccess(item)">
                                                    {{ item.isAccountLocked ? 'Enable' : 'Disable' }}
                                                </span>
                                            </v-btn>
                                        </template>
                                        <template v-slot:pending="{ item }"> </template>
                                        <template v-slot:item.action="{ item }">
                                            <update-user
                                                v-if="item.account && checkAdmin(currentLevel)"
                                                :current-level="currentLevel"
                                                :current-account="item"
                                                @updated="updateData($event)"
                                            ></update-user>
                                            <remove-pending
                                                v-if="!item.account && checkAdmin(currentLevel)"
                                                :current-level="currentLevel"
                                                :current-account="item"
                                                :table-view="tableView"
                                                @deleted="updateData($event)"
                                            ></remove-pending>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-col>
                            <v-col v-if="addPossibleUsersAccess" cols="5">
                                <div class="org-users-section">
                                    <v-navigation-drawer width="100%" dark permanent floating>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" style="justify-content: space-between">
                                                        <v-list-item-subtitle
                                                            style="
                                                                margin-top: 7px;
                                                                justify-content: space-between;
                                                                display: flex !important;
                                                            "
                                                        >
                                                            Possible User Accounts ({{
                                                                idleUsers ? idleUsers.length : 0
                                                            }})
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom max-width="200px">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon
                                                                        color="primary"
                                                                        dark
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    >
                                                                        {{ mdiHelpCircleOutline }}
                                                                    </v-icon>
                                                                </template>
                                                                <span
                                                                    >The following are existing user accounts that share
                                                                    the same email domain as your organization. You may
                                                                    choose to directly add these users to your
                                                                    organization or sub-organizations.</span
                                                                >
                                                            </v-tooltip>
                                                        </v-list-item-subtitle>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-navigation-drawer>
                                    <!-- <v-alert class="pa-5 pb-0" dense type="info" color="transparent">
                                        The following are existing user accounts that share the same email domain as
                                        your organization. You may choose to directly add these users to your
                                        organization or sub-organizations.
                                    </v-alert> -->
                                    <v-data-table
                                        style="background-color: transparent"
                                        dark
                                        class="org-data-table"
                                        :items="idleUsers"
                                        :search="search"
                                        :no-data-text="`No accounts`"
                                        :headers="userHeaders"
                                        disable-sort
                                    >
                                        <template v-slot:top>
                                            <v-text-field
                                                v-model="search"
                                                label="Search Possible User Accounts"
                                                outlined
                                                dense
                                                class="mx-4 mt-10"
                                            ></v-text-field>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <v-btn
                                                color="success"
                                                outlined
                                                small
                                                @click="
                                                    addPossibleAccount = true
                                                    selectedPossible = item
                                                "
                                                ><v-icon color="success">{{ mdiPlusCircleOutline }}</v-icon></v-btn
                                            >
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-col>
                            <v-dialog v-model="addPossibleAccount" width="750px">
                                <div
                                    class="container-bg"
                                    style="margin: auto; display: block; background: rgba(20, 20, 20, 0.8)"
                                >
                                    <div class="container-fg">
                                        <v-card dark style="background-color: transparent" elevation="0">
                                            <v-card-title style="background-color: transparent">
                                                <h1
                                                    style="
                                                        font-size: 36px;
                                                        letter-spacing: -0.08rem;
                                                        margin-left: -5px;
                                                        color: white;
                                                    "
                                                >
                                                    Add {{ selectedPossible.email }}?
                                                </h1>
                                            </v-card-title>
                                            <v-divider style="margin-bottom: 10px" color="gray"></v-divider>
                                            <v-row>
                                                <v-col>
                                                    <v-select
                                                        v-model="moveToOrg"
                                                        class="pa-3"
                                                        :items="orgSelections"
                                                        outlined
                                                        item-text="organizationName"
                                                        item-value="orgId"
                                                        return-object
                                                        dense
                                                        hide-details
                                                        label="Add to"
                                                    >
                                                    </v-select>
                                                    <v-checkbox
                                                        v-model="addAdmin"
                                                        class="pl-5"
                                                        :label="`Give admin privileges to ${selectedPossible.email}`"
                                                    ></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-divider style="margin-bottom: 25px" color="gray"></v-divider>

                                            <v-card-actions>
                                                <base-btn color="primary" text @click="addPossibleAccount = false">
                                                    Close
                                                </base-btn>
                                                <v-spacer></v-spacer>
                                                <base-btn
                                                    class="elevation-0 dialog-btns"
                                                    outlined
                                                    :disabled="!moveToOrg.orgId"
                                                    @click="confirmAddUser(selectedPossible)"
                                                >
                                                    Add
                                                </base-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </div>
                                </div>
                            </v-dialog>
                        </v-row>
                    </v-row>
                </div>
            </div>
        </div>
        <!-- <div v-if="currentView === 'Tree View'" class="org-container">
            <tree-view
                :current-level="currentLevel"
                :user-accounts="filterNormalUser(currentLevel.accounts)"
                :base-level-id="baseLevelId"
                @update="updateData($event)"
                @change="changeOrg($event)"
                @deleted="deletedOrg($event)"
            ></tree-view>
        </div> -->
        <v-snackbar v-model="snackbar">
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { navLinks } from '../navigation.js'
import {
    mdiArrowLeft,
    mdiAccountSupervisor,
    mdiPlusCircleOutline,
    mdiAccountAlert,
    mdiHelpCircleOutline
} from '@mdi/js'
import CreateSubOrg from '../../../components/branches/create_sub_org.vue'
import PrintOrgAddress from '../../../components/branches/print_address.vue'
import UpdateOrg from '../../../components/branches/update_org.vue'
import AddUser from '../../../components/branches/add_user.vue'
import UpdateUser from '../../../components/branches/update_user.vue'
import RemovePending from '../../../components/branches/remove_pending.vue'
import gql from 'graphql-tag'

export default {
    name: `Branches`,
    components: {
        CreateSubOrg,
        UpdateOrg,
        AddUser,
        UpdateUser,
        RemovePending,
        PrintOrgAddress
    },
    metaInfo: { title: `Your Account`, subTitle: `Organizations` },
    apollo: {
        queryIdleUsersWithSameDomain: {
            query: gql`
                query QueryIdleUsersWithSameDomain {
                    queryIdleUsersWithSameDomain {
                        email
                        id
                    }
                }
            `,
            update(data) {
                this.idleUsers = data.queryIdleUsersWithSameDomain || []
            }
        },
        resolveAccountOrganization: {
            variables() {
                return {
                    resolveAccountOrganizationId: this.currentLevel.baseAccountId
                }
            },
            skip() {
                return !this.currentLevel.baseAccountId
            },
            fetchPolicy: `network-only`,
            query: gql`
                query ResolveAccountOrganization($resolveAccountOrganizationId: String) {
                    resolveAccountOrganization(id: $resolveAccountOrganizationId) {
                        accounts {
                            account {
                                email
                            }
                            accountId
                            admin
                            requestedEmail
                            isAccountLocked
                        }
                        address {
                            city
                            country
                            line1
                            line2
                            postalCode
                            state
                        }
                        orgId
                        enterprise
                        parentOrgId
                        parentOrg {
                            orgId
                            organizationName
                        }
                        organizationName
                        createdByAccountId
                        admins {
                            account {
                                email
                                id
                            }
                            accountId
                            admin
                            requestedEmail
                        }
                        childrenOrg {
                            orgId
                            organizationName
                            address {
                                city
                                country
                                line1
                                line2
                                postalCode
                                state
                            }
                        }
                    }
                }
            `,
            update(data) {
                this.currentLevel = this.currentLevelObj(data.resolveAccountOrganization)
                this.currentLevel.accounts = this.currentLevel.accounts.map((e) => ({ ...e, email: e.requestedEmail }))
                if (!data.resolveAccountOrganization.parentOrgId) {
                    this.topOrgAdminsArray = data.resolveAccountOrganization.admins
                }
            }
        }
    },

    data() {
        return {
            mdiHelpCircleOutline,
            moveToOrg: { orgId: ``, organizationName: `` },
            idleUsers: [],
            searchUserAccounts: ``,
            search: ``,
            mdiAccountAlert,
            addAdmin: false,
            addPossibleAccount: false,
            selectedPossible: { email: `` },
            mdiPlusCircleOutline,
            mdiArrowLeft,
            links: navLinks,
            mdiAccountSupervisor,
            panel: 0,
            loading: true,
            tableView: true,
            snackbar: false,
            viewOptions: ['Table View', 'Tree View'],
            currentView: 'Table View',
            snackbarMessage: '',
            userId: this.$auth.user.id,
            baseLevelId: '',
            baseLevelParentOrgId: '',
            topOrgAdminsArray: [],
            noBranches: false,
            currentLevel: {
                baseAccountId: null,
                baseAccountName: null,
                childrenOrg: [],
                parentOrgId: null,
                parentOrgName: null,
                accounts: [],
                admins: [],
                address: {
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    country: '',
                    postalCode: ''
                }
            },
            subOrgHeaders: [
                {
                    text: 'Sub-Organization Name',
                    align: 'start',
                    sortable: false,
                    value: 'organizationName'
                },
                {
                    text: 'Address',
                    align: 'start',
                    sortable: false,
                    value: 'address'
                },
                {
                    text: '',
                    align: 'end',
                    sortable: false,
                    value: 'action'
                }
            ],
            userHeaders: [
                {
                    text: 'Account Email',
                    align: 'start',
                    sortable: false,
                    value: 'email'
                },
                {
                    text: 'Access',
                    align: 'end',
                    sortable: false,
                    value: 'access'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    sortable: false,
                    value: 'action'
                }
            ]
        }
    },
    computed: {
        addPossibleUsersAccess() {
            const admins = this.currentLevel.admins.map((e) => e.accountId)
            const currentAdmin = admins.includes(this.$auth.user.id)
            const topLevel = !this.currentLevel.parentOrgId
            const possibleAccounts = this.idleUsers && this.idleUsers.length > 0

            return currentAdmin && topLevel && possibleAccounts
        },
        orgSelections() {
            const result = [
                { organizationName: this.currentLevel.baseAccountName, orgId: this.currentLevel.baseAccountId },
                ...this.currentLevel.childrenOrg
            ]
            return result
        }
    },
    watch: {
        addPossibleAccount: {
            handler() {
                this.moveToOrg = { orgId: ``, organizationName: `` }
                this.addAdmin = false
            }
        }
    },
    created() {
        this.$apollo
            .query({
                query: gql`
                    query ResolveBaseAccountOrganization {
                        resolveBaseAccountOrganization {
                            accounts {
                                account {
                                    email
                                }
                                accountId
                                admin
                                requestedEmail
                            }
                            parentOrgId
                            orgId
                            organizationName
                            admins {
                                account {
                                    email
                                    id
                                }
                                accountId
                                admin
                                requestedEmail
                            }
                        }
                    }
                `
            })
            .then((data) => {
                if (data.data.resolveBaseAccountOrganization !== null) {
                    const resolveBase = data.data.resolveBaseAccountOrganization
                    this.currentLevel.baseAccountId = resolveBase.orgId
                    this.baseLevelId = resolveBase.orgId
                    this.baseLevelParentOrgId = resolveBase.parentOrgId
                    this.loading = false
                } else {
                    this.noBranches = true
                    this.loading = false
                }
            })
    },
    methods: {
        confirmAddUser(user) {
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation AddUserToOrganization($admin: Boolean!, $email: String!, $orgId: String!) {
                            addUserToOrganization(admin: $admin, email: $email, orgId: $orgId) {
                                complete
                                error
                                success
                                uid
                            }
                        }
                    `,
                    variables: {
                        admin: this.addAdmin,
                        email: user.email,
                        orgId: this.moveToOrg.orgId
                    }
                })
                .then((data) => {
                    this.snackbarMessage = data.data.addUserToOrganization.success
                        ? `${user.email} has successfully been added to ${this.moveToOrg.organizationName}.`
                        : `Error adding ${user.email} to ${this.moveToOrg.organizationName}`
                    this.snackbar = true
                    this.addPossibleAccount = false
                    this.$apollo.queries.queryIdleUsersWithSameDomain.refetch()
                    this.$apollo.queries.resolveAccountOrganization.refetch()
                })
                .catch((e) => {
                    this.snackbarMessage = `Error: ${e}`
                    this.snackbar = true
                })
        },
        checkTopOrg() {
            const retValue =
                !!this.topOrgAdminsArray &&
                !!this.topOrgAdminsArray.find((item) => item.accountId === this.$auth.user.id)
            return retValue
        },
        updateData(status) {
            this.$apollo.queries.resolveAccountOrganization.refetch()
            this.$apollo.queries.queryIdleUsersWithSameDomain.refetch()
            this.snackbar = true
            this.snackbarMessage = status
        },
        async deletedOrg(obj) {
            await this.$apollo.queries.resolveAccountOrganization
                .fetchMore({
                    variables: {
                        resolveAccountOrganizationId: obj.parentId
                    }
                })
                .then((data) => {
                    this.currentLevel.baseAccountId = data.data.resolveAccountOrganization.orgId
                    this.snackbar = true
                    this.snackbarMessage = obj.status
                })
        },
        currentLevelObj(data) {
            return {
                baseAccountId: data.orgId,
                baseAccountName: data.organizationName,
                enterprise: data.enterprise || false,
                childrenOrg: data.childrenOrg,
                parentOrgId: data.parentOrgId,
                parentOrgName: data.parentOrg ? data.parentOrg.organizationName : null,
                accounts: data.accounts,
                admins: data.admins,
                address: data.address
            }
        },
        changeOrg(org) {
            this.currentLevel.baseAccountId = org
        },
        checkAdmin(level) {
            const account = level.admins.find((e) => e.accountId === this.$auth.user.id)
            if (account) {
                return true
            } else {
                return false
            }
        },
        filterAdmins(accounts) {
            const admins = accounts.filter((e) => e.admin === true)
            return admins
        },
        filterNormalUser(accounts) {
            const user = accounts.filter((e) => e.admin === false)
            return user
        },
        removePendingUser(account) {
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation RemoveUserFromOrganization($orgId: String!, $email: String, $userId: String) {
                            removeUserFromOrganization(orgId: $orgId, email: $email, userId: $userId) {
                                complete
                                error
                                success
                                uid
                            }
                        }
                    `,
                    variables: {
                        orgId: this.currentLevel.baseAccountId,
                        email: account.requestedEmail
                    }
                })
                .then((data) => {
                    if (data.removeUserFromOrganization.success === true) {
                        this.snackbar = true
                        this.snackbarMessage = `'${account.requestedEmail}' successfully removed`
                    } else {
                        this.snackbar = true
                        this.snackbarMessage = `Error removing '${account.requestedEmail}'`
                    }
                })
        },
        userAccountAccess(item) {
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation disableUserAccount($userId: String!) {
                            disableUserAccount(userId: $userId) {
                                success
                                error
                                uid
                                complete
                            }
                        }
                    `,
                    variables: {
                        userId: item.accountId
                    }
                })
                .then((data) => {
                    if (data.data.disableUserAccount.success === true) {
                        this.snackbar = true
                        this.snackbarMessage = 'User permissions have changed.'
                    } else {
                        this.snackbar = true
                        this.snackbarMessage = 'Error in changing user permissions.'
                    }
                })
        }
    }
}
</script>

<style>
.expansion-header {
    margin: auto;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    background-image: linear-gradient(155deg, rgba(90, 90, 90, 0.6), rgba(255, 255, 255, 0));
}
.expansion-header-first {
    margin: auto;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    background-image: linear-gradient(155deg, rgba(90, 90, 90, 0.6), rgba(255, 255, 255, 0));
}
.expanded-panels .v-expansion-panel-content__wrap {
    padding: 0px;
}
.header-row {
    background-image: linear-gradient(155deg, rgba(90, 90, 90, 0.6), rgba(255, 255, 255, 0));
    color: hsla(0, 0%, 100%, 0.7);
    font-size: 0.875rem;
}
</style>
